import { whenDocumentReady } from '../../../../../paws/assets/frontend/js/helper/documentready';
import {detectBreakpoint} from "../../../../assets/frontend/js/helper/breakpoint";

whenDocumentReady(initModule);
function initModule() {
    if (window.headerHeight < 1) {
        setTimeout(function () {
            initModule()
        }, 250);
    } else {
        initGumshoe();
    }
}

function CalculateOffset() {
    let sticky = document.querySelector('[paws-component="noss-scrollspy"][paws-template="default"]');
    let offset = sticky.getBoundingClientRect().height;

    if (window.headerHeight > 0) {
        offset = offset + window.headerHeight;
    }

    const wpadminbar = document.querySelector('#wpadminbar');
    if (wpadminbar) {
        offset = offset + wpadminbar.offsetHeight;
    }

    return offset;
}

function scrollToHorizontally(el) {
    const elRight = el.offsetLeft + el.offsetWidth;
    const elLeft = el.offsetLeft;

    const elParentRight = el.parentNode.offsetLeft + el.parentNode.offsetWidth;
    const elParentLeft = el.parentNode.offsetLeft;

    // check if right side of the element is not in view
    if (elRight > elParentRight + el.parentNode.scrollLeft) {
        el.parentNode.scrollLeft = elRight - elParentRight;
    }

    // check if left side of the element is not in view
    else if (elLeft < elParentLeft + el.parentNode.scrollLeft) {
        el.parentNode.scrollLeft = elLeft - elParentLeft;
    }
}

function initGumshoe() {
    var nossscrollspy = new Gumshoe('[paws-component="noss-scrollspy"][paws-template="default"] a', {
        offset: function () {
            return CalculateOffset();
        }
    });

    document.addEventListener('gumshoeActivate', function (event) {
        let sticky = document.querySelector('[paws-component="noss-scrollspy"][paws-template="default"]');
        if (!sticky.classList.contains('active')) {
            sticky.classList.add('active');
            let maincontent = document.querySelector('.maincontent');
            maincontent.style.paddingTop = sticky.getBoundingClientRect().height + 'px';
        }
        scrollToHorizontally(event.target);

    }, false);

    document.addEventListener('gumshoeDeactivate', function (event) {
        let sticky = document.querySelector('[paws-component="noss-scrollspy"][paws-template="default"]');
        if (!sticky.querySelector('.active')) {
            if (sticky.classList.contains('active')) {
                sticky.classList.remove('active');
                let maincontent = document.querySelector('.maincontent');
                maincontent.style.paddingTop = 0;
            }
        }
    }, false);
}